import { KText } from '@/ui-library/components/text';
import { formatBytes } from '@/utils/format-bytes';
import { Flex, Icon, Link } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import AttachmentDoc from '@/assets/icons/attachements/AttachmentDoc';
import AttachmentPdf from '@/assets/icons/attachements/AttachmentPdf';
import AttachmentDocx from '@/assets/icons/attachements/AttachmentDocx';
import AttachmentJpg from '@/assets/icons/attachements/AttachmentJpg';
import AttachmentOdt from '@/assets/icons/attachements/AttachmentOdt';
import AttachmentPng from '@/assets/icons/attachements/AttachmentPng';
import AttachmentDefault from '@/assets/icons/attachements/AttachmentDefault';
import { EllipsisText } from '@/design-system/ellipsis';

export const AttachmentPreview = ({
  file,
  opacity = 1,
  bg = 'rgba(229, 229, 229, 0.37)',
  AfterContent,
}) => {
  const [fileUrl, setFileUrl] = useState(null);
  const [fileObj, setFileObj] = useState(null);

  const fileConfigs = [
    {
      type: 'application/pdf',
      icon: AttachmentPdf,
    },
    {
      type: 'application/msword',
      icon: AttachmentDoc,
    },
    {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      icon: AttachmentDocx,
    },
    {
      type: 'image/jpeg',
      icon: AttachmentJpg,
    },
    {
      type: 'image/jpg',
      icon: AttachmentJpg,
    },
    {
      type: 'image/png',
      icon: AttachmentPng,
    },
    {
      type: 'application/vnd.oasis.opendocument.text',
      icon: AttachmentOdt,
    },
    // Default fallback
    {
      type: 'default',
      icon: AttachmentDefault,
    },
  ];

  const getFileIcon = (fileType) => {
    const config = fileConfigs.find((config) => config.type === fileType);
    return config ? config.icon : AttachmentDefault;
  };

  useEffect(() => {
    if (file instanceof File) {
      setFileUrl(URL.createObjectURL(file));
      setFileObj(file);
    } else {
      setFileUrl(file?.url);
      setFileObj({
        id: file?.id,
        url: file?.url,
        name: file?.filename,
        size: file?.byte_size,
        type: file?.content_type,
      });
    }
  }, [file]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!fileUrl) return null;
  return (
    <Flex
      minW="175px"
      bg={bg}
      borderRadius="6px"
      px="12px"
      py="6px"
      alignItems="center"
      gap="6px"
      className="preview-attachment"
      opacity={opacity}
    >
      <Icon
        as={getFileIcon(fileObj?.type)}
        w="42px"
        h="42px"
        borderRadius={'6px'}
      />
      <Flex flexDirection="column" flex="1">
        <Link
          href={fileUrl}
          target="_blank"
          pointerEvents={`${Number(opacity) === 1 ? 'unset' : 'none'}`}
          _focus={{ boxShadow: 'none' }}
        >
          <KText as="span" fontSize="14px" fontWeight="semiBold">
            <EllipsisText
              as="span"
              text={fileObj?.name?.substr(0, fileObj?.name?.lastIndexOf('.'))}
              length={13}
              color="secondary-900"
            />
            <KText as="span" color="secondary-900" fontWeight="semiBold">
              {fileObj?.name?.substr(fileObj?.name?.lastIndexOf('.'))}
            </KText>
          </KText>
        </Link>
        <KText
          as="span"
          color="secondary-700"
          fontSize="12px"
          fontWeight="semiBold"
        >
          {formatBytes(fileObj?.size)}
        </KText>
      </Flex>
      {AfterContent && AfterContent}
    </Flex>
  );
};
